export default __webpack_public_path__ + "static/media/ML.d041d98f.png";